import React from 'react';
import styled from 'styled-components';
import Button from '../base/Button.jsx';

class InformationCard extends React.Component {

    constructor(props) {
        super(props);

        this.container = styled.div `
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid ${props => props.theme.colors.border};
        &.editing{
            position: relative;
            .card_head{
                background-color: ${props => props.theme.colors.dark[1]};
                color: #fff;
            }
            .card_list{
                ul{
                    li{
                        &:not(.modifiable){
                            cursor: not-allowed;
                            background-color: ${props => props.theme.colors.gray[3]};
                            color: ${props => props.theme.colors.gray[2]};
                        }
                        &.modifiable{
                            cursor: pointer;
                            &:HOVER{
                                background-color: ${props => props.theme.colors.blue[1]};
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
        .card_head{
            padding: 14px 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: sticky;
            top: 0;
            left: 0;
            right: 0;
            background-color: #fff;
            z-index: 2;
            border-bottom: 1px solid ${props => props.theme.colors.border};
            .card_title, .card_title_buttons{
                display: inline-block;
                vertical-align: middle;
                width: 50%;
                white-space: nowrap;
            }
            .card_title{
                font-size: 22px;
                font-weight: bold;
            }
            .card_title_buttons{
                text-align: right;
                button{
                    margin-left: 8px;
                }
            }
        }
        .card_body{
            padding: 12px 16px;
            .task_description{
                font-size: 14px;
                opacity: 0.6;
            }
        }
        .card_list{
            border-top: 1px solid ${props => props.theme.colors.border};
            ul{
                li{
                    padding: 8px 12px;
                    border-bottom: 1px solid ${props => props.theme.colors.border};
                    &:last-child{
                        border-radius: 0 0 4px 4px;
                        border-bottom: 0;
                    }
                    .card_list_label{
                        font-size: 14px;
                        margin-bottom: 8px;
                        opacity: 0.7;
                    }
                    .card_list_data{
                        font-weight: bold;
                        font-size: 16px;
                        &.free_text{
                            font-weight: normal;
                            white-space: pre-line;
                            background-color: #eeeeee;
                            padding: 4px 8px;
                            border-radius: 4px;
                            opacity: 0.8;
                            font-size: 14px;
                            line-height: 16px;
                        }
                        span{
                            &.link{
                                cursor: pointer;
                                color: ${props => props.theme.colors.blue[1]};
                                text-decoration: underline;
                                &:HOVER{
                                    color: ${props => props.theme.colors.blue[0]};
                                }
                            }
                        }
                    }
                }
            }
        }
        `;

    }

    renderTitleButton(item, i) {
        let props = {};

        props.label = item.label;
        if (item.color) {
            props[item.color] = true;
        }
        if (item.onClick) {
            props["onClick"] = item.onClick;
        }

        return (
            <Button
                key={i}
                filled
                {...props}
            />
        );
    }

    render() {
        return (
            <this.container className={`information_card ${this.props.editing ? 'editing' : ''}`}>
                <div className="card_head">
                    <div className="card_title">
                        {this.props.title}
                    </div>
                    <div className="card_title_buttons">
                        { (this.props.title_buttons || []).map((item, i) => this.renderTitleButton(item, i)) }
                    </div>
                </div>
                <div className="card_list">
                    <ul>
                        {
                            this.props.items.map((item, i) => {
                                return (
                                    <li
                                        key={i}
                                        className={`${item.modifiable ? 'modifiable' : ''}`}
                                        onClick={() => {return item.onClick && item.onClick();}}>
                                        <p className="card_list_label">
                                            {item.label}
                                        </p>
                                        <p className={`card_list_data ${item.free_text ? 'free_text' : ''}`}>
                                            {item.data}
                                        </p>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </this.container>
        );
    }
}

export default InformationCard;



// WEBPACK FOOTER //
// ./src/components/base/InformationCard.jsx